import { GET_KEYWORDS_REQUEST, GET_KEYWORDS_SUCCESS, GET_KEYWORDS_FAILURE, GET_LOCATIONS_REQUEST, GET_LOCATIONS_SUCCESS, GET_LOCATIONS_FAILURE, GET_PROFILES_REQUEST, GET_PROFILES_SUCCESS, GET_PROFILES_FAILURE } from "./candidateAction";

const initialState = {
    keywords: {
        data: [],
        loading: false,
        error: null
    },
    locations: {
        data: [],
        loading: false,
        error: null
    },
    profiles: {
        data: [],
        loading: false,
        error: null
    }
};

const resourcesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_KEYWORDS_REQUEST:
            return {
                ...state,
                keywords: { ...state.keywords, loading: true, error: null }
            };
        case GET_KEYWORDS_SUCCESS:
            return {
                ...state,
                keywords: { ...state.keywords, data: action.payload, loading: false }
            };
        case GET_KEYWORDS_FAILURE:
            return {
                ...state,
                keywords: { ...state.keywords, loading: false, error: action.payload }
            };

        case GET_LOCATIONS_REQUEST:
            return {
                ...state,
                locations: { ...state.locations, loading: true, error: null }
            };
        case GET_LOCATIONS_SUCCESS:
            return {
                ...state,
                locations: { ...state.locations, data: action.payload, loading: false }
            };
        case GET_LOCATIONS_FAILURE:
            return {
                ...state,
                locations: { ...state.locations, loading: false, error: action.payload }
            };

        case GET_PROFILES_REQUEST:
            return {
                ...state,
                profiles: { ...state.profiles, loading: true, error: null }
            };
        case GET_PROFILES_SUCCESS:
            return {
                ...state,
                profiles: { ...state.profiles, data: action.payload, loading: false }
            };
        case GET_PROFILES_FAILURE:
            return {
                ...state,
                profiles: { ...state.profiles, loading: false, error: action.payload }
            };
        default:
            return state;
    }
};

export default resourcesReducer;